var actions = {
	next: "Next",
	confirm: "Confirm",
	"continue": "Continue"
};
var errors = {
	unknown: "An unknown error occurred",
	contactSupport: "An error occurred. Please contact support.",
	tryAgain: "An error occurred. Please try again.",
	submit: "There was an error with your submission."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "Paypal",
	picarto: "Picarto",
	tiktok: "Tiktok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Log in with {name}",
	signupWith: "Sign up with {name}"
};
var alreadyHaveAccount = {
	company: "Already have a {company} account?",
	text: "Already have Streamlabs ID?",
	link: "Log in"
};
var noAccount = {
	text: "Don't have an account yet?",
	link: "Sign Up"
};
var validation = {
	email: {
		invalid: "Please enter a valid email address"
	},
	password: {
		required: "Password is required",
		min: "Password must be greater than 8 characters",
		number: "Password must have a number",
		upper: "Password must contain an upper-case character",
		special: "Password must have a special character"
	},
	username: {
		invalid: "Name must be at least 5 characters"
	},
	code: {
		minmax: "Code should be between 6 and 10 characters"
	}
};
var poweredBy = "Powered by <company>Streamlabs</company>";
var card = {
	"404": {
		title: "Company not found!",
		desc: "Please try again later or contact support."
	},
	company: {
		logoAlt: "{company} Logo"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6-digit auth code/8-digit backup code",
	successText: "Success! Redirecting...",
	remember: "Remember this device for 30 days"
};
var createTfa = {
	scan: {
		title: "Enable 2-Factor Authentication",
		lead: "Click/copy or scan code below using your preferred authentication app. We recommend using an app like <app0 />, <app1 /> or <app2 /> to safely store your codes.",
		copied: "Copied!",
		instructions: "Or manually input this code into your authentication app.",
		copy: "Copy code",
		proceed: "Confirmation"
	},
	confirm: {
		title: "Confirm Your 2-Factor Authentication",
		lead: "Submit a generated 2FA code below to confirm and enable 2-Factor Authentication.",
		label: "2-Factor Auth Code (6 digits)",
		verify: "Verify Code",
		next: "Success! Next Step"
	},
	save: {
		title: "Save Your Recovery Codes",
		lead: "Save your recovery codes below incase you lose access to your 2-Factor Authenticator. After you close this modal these codes will not be available again.",
		label: "Recovery Codes",
		download: "Download Recovery Codes",
		copied: "Codes copied!",
		finished: "Finished",
		downloadFirstMessage: "Please download your recovery codes before continuing."
	}
};
var emailLoginForm = {
	buttonText: "Log In",
	emailPlaceholder: "Email",
	passwordPlaceholder: "Password"
};
var emailSignupForm = {
	buttonText: "Sign up",
	emailPlaceholder: "Set an email",
	passwordPlaceholder: "Set a password",
	usernamePlaceholder: "Your Name",
	ageLabel: "Date of Birth",
	agePlaceholder: "MM/DD/YYYY",
	agreeText: "I agree to Streamlabs <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
	agreePromotional: "I agree to receive special promotional offers, tips and tricks, and news from Streamlabs",
	agreeError: "Please agree to Streamlabs terms and conditions"
};
var ageInput = {
	invalidDate: "Please enter a valid birthday",
	futureDate: "Birth date must be in the past",
	minDate: "Dates before year {year} are not allowed",
	minAge_one: "You must be {years} year of age or older to use Streamlabs",
	minAge_two: "You must be {years} years of age or older to use Streamlabs",
	minAge_other: "You must be {years} years of age or older to use Streamlabs"
};
var forgotPasswordForm = {
	emailPlaceholder: "Email",
	back: "Back to Login",
	successText: "Success! We've sent you with a password-reset code",
	buttonText: "Request Reset Email",
	create: {
		successText: "Success! We've sent you a verification code, to get you started!",
		buttonText: "Request Verification Code"
	},
	errors: {
		notFound: "No account found by this email address"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "Forgot your password?",
	lead: "If you need to reset your password, please input your email below and we'll send you an email to start the process.",
	resetTitle: "Reset Your Password",
	resetLead: "You should have received a code via email. Complete the form to reset your password.",
	create: {
		title: "Create your password",
		lead: "Congratulations on creating your Streamlabs ID! One more step and you'll be able to login across all of Streamlabs!",
		resetTitle: "Choose a password",
		resetLead: "You should have received a code via email. Use it and complete the form to set your password."
	},
	successText: "Success! Redirecting...",
	signInTitle: "Already have an account?",
	signInBtn: "Log In"
};
var checkTfaCard = {
	title: "2-Factor Authentication Check",
	lead: "Please enter a 2-Factor Auth Code below to continue.",
	successText: "2FA confirmed successfully!",
	back: "Go Back"
};
var verifyEmailCard = {
	title: "Verify Your Email",
	lead: "Check your email for a 8-digit code from Streamlabs and input below.",
	back: "Go Back",
	successText: "Email verified successfully!"
};
var upgradeCard = {
	confirm: {
		title: "Confirm {company} connection",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Going forward you will be able to log in to {company} with the email and password provided.",
			"You can access all other products from Streamlabs with your ID and connect other existing accounts if you have any.",
			"Your {company} account will not be impacted by this change."
		],
		button: "Confirm",
		cancel: "Cancel",
		switchAccount: "Switch Account",
		success: "Connecting..."
	},
	confirmed: {
		title: "Success!",
		subtitle: "Your Streamlabs ID has been created and {company} account is connected.",
		text: "You can use your Streamlabs ID for all Streamlabs products. If you have existing accounts, you can connect them to this ID from within each app.",
		button: "Close"
	},
	error: {
		user: "User identification failed. Please try logging in again or contact support."
	}
};
var confirmCard = {
	confirm: {
		title: "Confirm {company} Connection",
		subtitle: "We found an account with a matching email. Would you like to merge this account with Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"You will be able to log in to {company} with the email and password you provided through Streamlabs ID.",
			"You can access all other products from Streamlabs with your ID and connect other existing accounts if you have any.",
			"Your company account will not be impacted by this change."
		],
		button: "Confirm",
		cancel: "Cancel",
		switchAccount: "Switch Account",
		success: "Connecting..."
	},
	confirmed: {
		title: "Success!",
		subtitle: "Your Streamlabs ID has been created and {company} account is connected.",
		text: "You can use your Streamlabs ID for all Streamlabs products. If you have existing accounts, you can connect them to this ID from within each app.",
		button: "Close"
	},
	error: {
		user: "User identification failed. Please try logging in again or contact support."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Your ID already has a {company} account connected",
		subtitle: "Would you like to unlink the connected account and link to your current Streamlabs account?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"You will be able to log in to Streamlabs with the email and password you provided for Streamlabs ID.",
			"You can access all other products from Streamlabs with your ID and connect other existing accounts if you have any.",
			"Your Streamlabs account will not be impacted by this change."
		],
		button: "Confirm",
		cancel: "Cancel",
		switchAccount: "Switch Account",
		success: "Connecting...",
		agreeLabel: "I understand that by making this connection, I will lose access to the existing {company} account that is tied to Streamlabs ID."
	},
	confirmed: {
		title: "Success!",
		subtitle: "Your Streamlabs ID has been created and {company} account is connected.",
		text: "You can use your Streamlabs ID for all Streamlabs products. If you have existing accounts, you can connect them to this ID from within each app.",
		button: "Close"
	},
	error: {
		user: "User identification failed. Please try logging in again or contact support."
	}
};
var loginCard = {
	title: "Log In",
	lead: "Log in to <company>{company}</company> with <id>Streamlabs ID</id>",
	accountExists: "It looks like you have a <b>Streamlabs ID</b>. Try signing in with your email.",
	forgotPassword: "Forgot password?",
	successText: "Success! Redirecting...",
	signInTitle: "Log in with a platform"
};
var loginSourcesCard = {
	title: "Log In",
	lead: "Log in with email/password",
	withSlId: "Log in with Streamlabs ID",
	noAccountMessage: "We don’t see an account associated with this login method. Please try a different log in method or <signup>Sign Up</signup> if you haven’t yet.",
	accountExistsMessage: "Your Twitch email address is already associated with a Streamlabs. Please try signing in with your Streamlabs email and password."
};
var resetPasswordForm = {
	emailPlaceholder: "Email",
	codePlaceholder: "6-8 Digit Email Code",
	tfaCodePlaceholder: "2FAuthenticator Code",
	newPasswordPlaceholder: "New Password",
	tfaError: "Reset code should be between 6 and 10 characters",
	next: "Received the code?",
	back: "Back to Forgot Password",
	buttonText: "Change Password",
	successText: "Password Reset Successfully",
	create: {
		back: "Back to start",
		buttonText: "Set Password",
		successText: "Password Set Successfully"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Current Password",
	newPasswordPlaceholder: "New Password",
	newPasswordConfirmationPlaceholder: "Confirm New Password",
	buttonText: "Change Password",
	successText: "Password updated successfully",
	newPasswordConfirmationError: "New passwords do not match",
	back: "Back to dashboard"
};
var changePasswordCard = {
	title: "Change Your Password",
	lead: "Enter your current password along with a new password below.",
	successText: "Password updated successfully"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6-digit auth code/8-digit backup code",
	successText: "2FA removed successfully",
	removeBtn: "Confirm & Remove"
};
var removeTfaCard = {
	title: "Remove 2-Factor Authentication",
	lead: "Enter a 2FA confirmation code below to remove Two-Factor Authentication from your account.",
	successText: "2FA removed successfully",
	back: "Back to dashboard"
};
var verifyEmailForm = {
	codePlaceholder: "8-digit code from email",
	tfaCodePlaceholder: "2FAuthenticator Code",
	emailPlaceholder: "Email Address",
	buttonText: "Verify Email",
	successText: "Email Verified Successfully",
	requestBtn: "Request New Code",
	requestingBtn: "Requesting...",
	requestSuccess: "A code has been sent to your email",
	requestAgain: "Request Again in {seconds}s",
	tfaError: "Reset code should be between 6 and 10 characters",
	back: "Go Back"
};
var signupCard = {
	title: "Sign Up",
	lead: "Create a <id>Streamlabs ID</id> account to use <company>{company}</company>",
	successText: "Success! Redirecting..."
};
var signupSourcesCard = {
	title: "Sign Up",
	lead: "Create a <id>Streamlabs ID</id> account to use <company>{company}</company>",
	withSlId: "Create a Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Choose an account",
		lead: "to continue to <b>{company}</b>",
		authorize: "Authorize",
		authorizeSuccess: "Success!",
		cancel: "Cancel",
		disclaimer: {
			streamlabs: "Continuing will share your Streamlabs ID (name, email address, language preference, and profile picture) with <b>{company}</b>. By authorizing an account with <b>{company}</b>, you hereby agree to <b>{company}</b>’s <privacy>privacy policy</privacy> and <terms>terms of service</terms>.",
			"default": "To continue, Streamlabs will share your name, email address, language preference, and profile picture with <b>{company}</b>. By authorizing an account with <b>{company}</b>, you hereby agree to <b>{company}</b>’s <privacy>privacy policy</privacy> and <terms>terms of service</terms>."
		},
		emailRequired: "Email verification required before proceeding",
		tfaRequired: "2-Factor Authentication required before proceeding",
		ageRequired: "Age verification required before proceeding"
	},
	login: {
		title: "Log into {company}",
		lead: "You must be logged in to connect accounts",
		loginBtn: "Proceed to login"
	},
	error: {
		title: "Log into {company}",
		lead: "Your request could not be authorized at this time.",
		verifyEmail: "Verify Email",
		verify2fa: "Verify 2FA",
		verifyDob: "Verify Age"
	},
	"switch": {
		btn: "Use another account"
	}
};
var appsDropdown = {
	label: "Streamlabs products & apps",
	viewMore: "Expand",
	viewLess: "Collapse"
};
var platformButtons = {
	loginWithPlatform: "Log in with a platform",
	signUpWithPlatform: "Sign up with a platform",
	signUpLead: "We support live streaming to many more platforms, these are just the sign up options."
};
var ultraCheckoutCard = {
	title: "Level up your live streams, branding, editing, and more with <b>Streamlabs Ultra</b>",
	badge: "Includes <b>{planName}</b>",
	totalValue: "{price, currency} value",
	price: {
		month: "{price, currency}/mo",
		year: "{price, currency}/yr"
	},
	description: {
		month: "Access premium features across the full suite including <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, and more, available at one, affordable price.",
		year: "Access premium features across the full suite including <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, and more, available at one, affordable price."
	},
	seeIncluded: "Learn More",
	buyNow: "Upgrade"
};
var ultraCheckoutBanner = {
	title: "Level up your live streams, branding, editing, and more with <b>Streamlabs Ultra</b>",
	badge: "Includes <b>{planName}</b>",
	totalValue: "{price, currency} value",
	price: {
		month: "{price, currency}/mo",
		year: "{price, currency}/yr"
	},
	description: {
		month: "Access premium features across the full suite including <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, and more, available at one, affordable price. <link />",
		year: "Access premium features across the full suite including <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, and more, available at one, affordable price. <link />"
	},
	seeIncluded: "Learn More",
	buyNow: "Upgrade"
};
var connect = {
	waitMessage: "Merging data. Please do not close this window."
};
var verifyPasswordCard = {
	success: "Password verified successfully",
	title: "Please re-authenticate to verify",
	lead: "Log in with your existing email and password to continue updating your Streamlabs ID.",
	buttonText: "Next"
};
var emailChangeForm = {
	agreeError: "Please verify that you understand this action",
	buttonText: "Next",
	emailPlaceholder: "New Email Address",
	agreeText: "I understand that once verified, my Streamlabs ID will change across all Streamlabs products it’s connected to."
};
var verifyNewEmailCard = {
	title: "Change your Streamlabs ID",
	lead: "Provide a new email to use as your Streamlabs ID. We will send a 6-8 digit verification code to this address.",
	successText: "New email available"
};
var verifyNewEmailOwnershipCard = {
	title: "Verify your updated Streamlabs ID",
	lead: "Check your email for a 8-digit code from Streamlabs and input below.",
	buttonText: "Confirm",
	back: "Back",
	codePlaceholder: "8-digit code from email",
	successText: "Email ownership verified successfully"
};
var verifyTfaCard = {
	title: "2-factor authentication code",
	lead: "Input the 6 digit verification code from your authentication app.",
	codePlaceholder: "6-digit code",
	buttonText: "Confirm",
	successText: "2-Factor authentication confirmed",
	back: "Back"
};
var ageGateForm = {
	ageLabel: "Date of Birth",
	agePlaceholder: "MM/DD/YYYY"
};
var ageGateCard = {
	title: "Complete account setup",
	lead: {
		years: "You must be {years} or older to create an account. <br />Enter your date of birth to finalize setup.",
		noYears: "You must provide your date of birth to create an account. <br />Enter it to finalize setup."
	},
	successText: "Congrats! Account setup complete."
};
var connectOneClick = {
	errors: {
		"auto-redirect": "Login failed. Please contact support."
	},
	title: {
		company: "Log in to {company} with Streamlabs ID",
		noCompany: "Log in with Streamlabs ID"
	},
	disclaimer: "To create your account, Streamlabs will share your email and name with Streamlabs. See Streamlabs's Privacy Policy for more details.",
	buttonText: {
		username: "Continue as {name}",
		noUsername: "Continue with Streamlabs ID"
	}
};
var enUS = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard,
	connectOneClick: connectOneClick
};

export { enUS as e };
//# sourceMappingURL=en-US.es.js.map
